import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Checkbox,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Chip,Link
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
  
} from "../../../ui-components/global/utils";
import FileUploadIconButton from "@mui/icons-material/PictureAsPdfOutlined";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  AttendanceEntryPost,
  // AttendanceEntryGet,
  wfhpostData,
  HomeworkEvalGet,
  HomeworkEvalPOST,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  CheckinAutocomplete,
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
} from "../../../ui-components/global/Autocomplete";
import {
  GridToolbarContainer,
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridRowEditStopReasons,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import PreviewIcon from "@mui/icons-material/Preview";
import VisibilityIcon from '@mui/icons-material/Visibility';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import {
  AttendanceEntryGet,
  fetchExplorelitview,
  HomeworkGet,
} from "../../../store/reducers/Explorelitviewapireducer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendanceHistoryPDF from "../../reports/AttendanceHistoryPdf";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { nanoid } from "@reduxjs/toolkit";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { fileUpload, imageUpload } from "../../../store/reducers/Imguploadreducer";
import { getConfig } from "../../../config";
const EditHwevaluation = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  // const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  var recID = params.id;
  var accessID = params.accessID;
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const deploymentData = useSelector((state) => state.formApi.deploymentData);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const EMPID = sessionStorage.getItem("EmpId");
  console.log(EMPID, "--EMPID");
  const companyID = sessionStorage.getItem("companyId");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  var compID = sessionStorage.getItem("companyId");
  const [errorMsgData, setErrorMsgData] = useState(null);
const HWevaldata = useSelector((state) => state.formApi.HWevaldata);
console.log(HWevaldata, "--HWevaldata");

  // const HWteachdata = useSelector((state) => state.formApi.HWteachdata);
  // console.log(HWteachdata, "-HWteachdata");

const studrows = HWevaldata?.grid1 || [];
const evalrows = HWevaldata?.grid2 || [];

// ✅ total
const totalCount = evalrows.length;

// ✅ evaluated (EV)
const evaluatedCount = evalrows.filter(
  (row) => row.Status === "EV"
).length;

// ✅ pending (PE)
const pendingCount = evalrows.filter(
  (row) => row.Status === "PE"
).length;

// ✅ resubmit (RS)
const resubmitCount = evalrows.filter(
  (row) => row.Status === "RS"
).length;
 const config = getConfig();
  const baseurl1 = config.BASE_URL;
  console.log(baseurl1,"url path");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  
 useEffect(() => {
    console.log("MODE:", mode);
    if (!mode) return;
    if (mode == "EV") {
      console.log(" Calling API");
      dispatch(
        HomeworkEvalGet({
          HomeWorkID: recID,
          TeacherID: EMPID,

        }),
      );
    }
  }, [dispatch]);
  //post data
  const data = useSelector((state) => state.formApi.Data);
  console.log(data, "--data");


  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedPro, setSelectedPro] = useState([]);
  const [selecttargetDate, setSelectTargetDate] = useState("");

 

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData,
  );
  console.log(explorelistViewData, "--explorelistViewData");

  const [rows, setRows] = React.useState([]);
  // useEffect(() => {
  //   if (explorelistViewData?.length > 0) {
  //     setRows(explorelistViewData);
  //   }
  // }, [explorelistViewData]);


useEffect(() => {
  if (evalrows.length > 0) {
    setRows(evalrows);
  }
}, [evalrows]);

 
  // const handleApplyClick = async (values) => {
  //   const projecID = selectedPro?.map((proj) => proj.RecordID).join(",");

  //   console.log("PROJECT ID:", projecID);

  //   try {
  //     const resultAction = await dispatch(
  //       HomeworkGet({
  //         StandardID: values?.ProName?.RecordID,
  //         // Section:values?.milestone?.map((i) => i.RecordID).join(","),
  //         Section: values?.milestone?.RecordID,
  //         Description: values.description,
  //         TargetDate: values.targetdate,
  //         TeacherID: EMPID,
  //         Attachment: "",
  //       }),
  //     );

  //     const payload = resultAction?.payload;
  //     console.log(payload, "--payload");
  //     // return;
  //   } catch (error) {
  //     console.error("Error while applying attendance entry:", error);
  //     setRows([]);
  //   }
  // };

  const handleSaveButtonClick = async (values) => {
    const dataArray = rows.map((row) => ({
      DailyTaskID: row.DT_RECID || 0,
      StudentID: row.StudentID || 0,
      Score: row.Score || 0,
      AnswerSheet: row.AnswerSheet || row.FileName || "",
  //     AnswerSheet:
  // row.FileName ||
  // (row.AnswerSheet ? row.AnswerSheet.split("/").pop() : ""),
      Remarks: row.Remarks || "",
      Status: row.Status || "",
    }));

    console.log(dataArray, "--mapped data");

    const idata = {
      StandardID: values?.ProName?.RecordID,
      // Section:values?.milestone?.map((i) => i.RecordID).join(","),
      SectionID: values?.milestone?.RecordID,
      HomeWorkID: recID,
      CompanyID: compID,
      TeacherID: EMPID,
      data: dataArray, // ✅ correct key name
    };

    console.log(idata, "--Final Payload");

    // return;
    try {
      const response = await dispatch(
        HomeworkEvalPOST({
          idata: idata,
        }),
      );

      if (response.payload.Status === "Y") {
        console.log(response.payload.Msg, "--console the msg");
        toast.success(response.payload.Msg);
        navigate(-1);
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };
  const [rowModesModel, setRowModesModel] = React.useState({});

  // const handleRowEditStop = (params, event) => {
  //   // if (params.reason === GridRowEditStopReasons.rowFocusOut) {
  //   event.defaultMuiPrevented = true;
  //   // }
  // };

  // const handleDeleteClick = (id) => () => {
  //   setRows((prevRows) => {
  //     const rowExists = prevRows.some((row) => row.StudentID === id);

  //     if (rowExists) {
  //       toast.success("Deleted Successfully");
  //     }

  //     return prevRows.filter((row) => row.StudentID !== id);
  //   });

  //   setRowModesModel((prevModel) => {
  //     const updatedModel = { ...prevModel };
  //     delete updatedModel[id];
  //     return updatedModel;
  //   });
  // };

  // const handleEditClick = (StudentID) => () => {
  //   console.log("--calling Editclick");

  //   setRowModesModel({
  //     ...rowModesModel,
  //     [StudentID]: { mode: GridRowModes.Edit },
  //   });
  // };

  // const handleSaveClick = (StudentID) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [StudentID]: { mode: GridRowModes.View },
  //   });
  // };

  // const handleCancelClick = (StudentID) => () => {
  //   setRowModesModel({
  //     ...rowModesModel,
  //     [StudentID]: { mode: GridRowModes.View, ignoreModifications: true },
  //   });

  //   const editedRow = rows.find((row) => row.StudentID === StudentID);
  //   if (editedRow.isNew) {
  //     setRows(rows.filter((row) => row.StudentID !== StudentID));
  //   }
  // };

  // const processRowUpdate = (newRow) => {
  //   const updatedRows = rows.map((row) =>
  //     row.DT_RECID  === newRow.DT_RECID  ? newRow : row,
  //   );

  //   setRows(updatedRows);
  //   console.log(updatedRows, "--updatedRows");
  //   return newRow;
  // };
  // const handleRowModesModelChange = (newRowModesModel) => {
  //   setRowModesModel(newRowModesModel);
  // };

  function EvalTool(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Evaluation</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  function StudentTool(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Students & Assignment</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }



  const StudColumn = [
    {
      field: "SlNo",
      headerName: "SL#",
      width: 40,
    //   editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
     align: "right",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
  {
      headerName: "DT_RECID",
      field: "DT_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "StudentID",
      field: "StudentID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Student",
      field: "StudentName",
      width: 150,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
  
    {
      headerName: "Description",
      field: "Description",
      width: 350,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      field: "TargetDate",
      headerName: "Target Date",
      headerAlign: "center",
      width: 100,
      hide: false,
      editable: false,
    },
     {
      field: "AssignStatus",
      headerName: "AssignStatus",
      headerAlign: "center",
      width: 100,
      hide: true,
      editable: false,
    },

  
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Actions",
    //   width: 100,
    //   cellClassName: "actions",
    //   getActions: ({ id }) => {
    //     const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

    //     if (isInEditMode) {
    //       return [
    //         <GridActionsCellItem
    //           icon={<SaveIcon />}
    //           label="Save"
    //           material={{
    //             sx: {
    //               color: "primary.main",
    //             },
    //           }}
    //           onClick={handleSaveClick(id)}
    //         />,
    //         <GridActionsCellItem
    //           icon={<CancelIcon />}
    //           label="Cancel"
    //           className="textPrimary"
    //           onClick={handleCancelClick(id)}
    //           color="inherit"
    //         />,
    //       ];
    //     }

    //     return [
    //       <GridActionsCellItem
    //         icon={<EditIcon />}
    //         label="Edit"
    //         className="textPrimary"
    //         onClick={handleEditClick(id)}
    //         color="inherit"
    //       />,
    //       <GridActionsCellItem
    //         icon={<DeleteIcon />}
    //         label="Delete"
    //         onClick={handleDeleteClick(id)}
    //         color="inherit"
    //       />,
    //     ];
    //   },
    // },
  ];

const handleFileUpload = async (file, params) => {
  console.log("📂 Selected file:", file);
  console.log("params", params);

  const rowId = params.id;

  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "images");

    const res = await dispatch(imageUpload({ formData })).unwrap();

    console.log("✅ Upload response:", res);

    const uploadedPath = res?.path || res?.name || "";
    console.log("uploadedPath",uploadedPath);

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.DT_RECID === rowId
          ? {
              ...row,
              AnswerSheet: uploadedPath,
              FileName: file.name,
            }
          : row
      )
    );

      // ✅ SUCCESS TOAST
    toast.success(res?.Msg || "File uploaded successfully!");
  } catch (err) {
    console.error("❌ Upload failed:", err);
  }
};
  const EvalColumn = [
 {
      field: "SlNo",
      headerName: "SL#",
      width: 40,
      hide: false,
      // sortable: false,
      // filterable: false,
      headerAlign: "center",
      align: "right"
      // disableColumnMenu: true,
      // valueGetter: (params) => {
      //   const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

      //   const totalVisibleRows = params.api.getAllRowIds().length;
      //   const totalAllRows = params.api.getRowsCount();

      //   if (totalVisibleRows < totalAllRows) {
      //     return index + 1;
      //   } else {
      //     return page * pageSize + index + 1;
      //   }
      // },
    },
      {
      headerName: "DT_RECID",
      field: "DT_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
   {
      headerName: "StudentID",
      field: "StudentID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
    //   editable: false,
    },
    {
      headerName: "Student",
      field: "StudentName",
      width: 150,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
     {
      headerName: "HE_RECID",
      field: "HE_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
{
  field: "Score",
  headerName: "Score",
  width: 120,
  editable: true,

  valueFormatter: (params) => {
    if (!params.value && params.value !== 0) return "";
    return `${params.value} / 100`;
  },

  valueParser: (value) => {
    if (value === "") return "";
    return Number(value);
  },
},
{
  field: "AnswerSheet",
  headerName: "Answer Sheet",
  width: 100,
  editable: true,

  renderCell: (params) => {
    const fileUrl = params.row.AnswerSheet;
    const fileName =
      params.row.FileName || fileUrl?.split("/").pop();

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
       
        {/* Actions */}
        <Box display="flex" gap={1}>
          
          {/* ✅ Upload Button */}
          <IconButton
            size="small"
            color="warning"
            component="label"
          >
            <input
              hidden
              type="file"
              accept="*/*"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  handleFileUpload(file, params);
                }
              }}
            />
            <UploadFileIcon fontSize="small" />
          </IconButton>

          {/* ✅ Preview */}
          {fileUrl && (
            <IconButton
              size="small"
              color="primary"
               
              onClick={() =>
                window.open(
                  `${baseurl1}uploads/images/${fileUrl}`,
                  "_blank"
                )
              }
            >
              <PreviewIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    );
  },

  renderEditCell: (params) => (
    <IconButton
      size="small"
      color="warning"
      component="label"
    >
      <input
        hidden
        type="file"
        accept="*/*"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            handleFileUpload(file, params);
          }
        }}
      />
      <UploadFileIcon fontSize="small" />
    </IconButton>
  ),
},
  {
    field: "Remarks",
    headerName: "Remarks",
    headerAlign: "center",
     width: 300,
    editable: true,
    hide: false,
    // renderCell: (params) => (
    //   <Typography>{params.row.Remarks || "—"}</Typography>
    // ),
  },
{
  field: "Status",
  headerName: "Status",
  width: 150,
  editable: true,
  type: "singleSelect",
  valueOptions: [
    { value: "EV", label: "Evaluated" },
    { value: "PE", label: "Pending" },
    { value: "RS", label: "Resubmit" },
  ],
  valueFormatter: (params) => {
    const map = {
      EV: "Evaluated",
      PE: "Pending",
      RS: "Resubmit",
    };
    return map[params.value] || params.value;
  },
},
     {
      field: "StatusLabel",
      headerName: "StatusLabel",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
      {
      field: "EvaluatedBy",
      headerName: "EvaluatedBy",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
         {
      field: "EvaluatedOn",
      headerName: "EvaluatedOn",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
];

  const AttInitialvalues = {
    description: HWevaldata?.Description || "",
    targetdate: HWevaldata?.TargetDate || "",
     ProName: HWevaldata?.StandardID
    ? {
        RecordID: HWevaldata.StandardID,
        Name: HWevaldata.Standard || HWevaldata.StandardID, // fallback
      }
    : null,

  milestone: HWevaldata?.SectionID
    ? {
        RecordID: HWevaldata.SectionID,
        Name: HWevaldata.Section || HWevaldata.SectionID,
      }
    : null,

    Attachment: "",
  };




  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [empData, setempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setempData(null);
    }
  };
  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography
              variant="h3"
              sx={{ marginLeft: "10px", fontSize: "19px", color:"#0000D1" }}
            >
              Homework Evaluation
            </Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              // attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();

                // ✅ Clear DataGrid rows
                setRows([]);
                dispatch(resetTrackingData());
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                // gap="70px"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                {/* <Stack direction="row" spacing={2}> */}

                <TextField
                  name="date"
                  type="date"
                  label="Date"
                  variant="standard"
                  focused
                  value={selectedDate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.date && !!errors.date}
                  helperText={touched.date && errors.date}
                  sx={{ span: 2 }}
                />

                <TextField
                  name="targetdate"
                  type="date"
                  label="Target Date"
                  variant="standard"
                  focused
                  value={values.targetdate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.targetdate && !!errors.targetdate}
                  helperText={touched.targetdate && errors.targetdate}
                  sx={{ span: 2 }}
                />

                <CheckinAutocomplete
                  sx={{ span: 2 }}
                  name="ProName"
                  label={
                    <>
                      Standard
                      <span style={{ color: "red", fontSize: "20px" }}> *</span>
                    </>
                  }
                  id="ProName"
                  value={values.ProName}
                  onChange={(newValue) => {
                    setFieldValue("ProName", newValue);
                  }}
                  url={`${listViewurl}?data=${encodeURIComponent(
                    JSON.stringify({
                      Query: {
                        AccessID: "2119",
                        ScreenName: "Project",
                        Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                        Any: "",
                      },
                    }),
                  )}`}
                />
                {/* <MultiFormikOptimizedAutocomplete
                     sx={{ span: 2 }}
                    name="milestone"
                     label={
              <>
                Sections
                <span style={{ color: "red", fontSize: "20px" }}> * </span>
              </>
            }
                    id="milestone"
                    value={values.milestone}
                     onChange={(e, newValue) =>
                          setFieldValue("milestone", newValue)
                        }
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2105",
                          ScreenName: "Milestone",
                          Filter: `parentID='${values.ProName?.RecordID}' AND CompanyID='${compID}'`,
                          Any: "",
                        },
                      })
                    )}`}
                  /> */}
                <CheckinAutocomplete
                  sx={{ span: 2 }}
                  name="milestone"
                  label={
                    <>
                      Section
                      <span style={{ color: "red", fontSize: "20px" }}> *</span>
                    </>
                  }
                  id="milestone"
                  value={values.milestone}
                  onChange={(newValue) => {
                    setFieldValue("milestone", newValue);
                  }}
                  url={`${listViewurl}?data=${encodeURIComponent(
                    JSON.stringify({
                      Query: {
                        AccessID: "2105",
                        ScreenName: "Milestone",
                        Filter: `parentID='${values.ProName?.RecordID}' AND CompanyID='${compID}'`,
                        Any: "",
                      },
                    }),
                  )}`}
                />

                {/* LEFT SIDE */}
                <TextField
                  name="description"
                  type="text"
                  label="Description"
                  variant="standard"
                  focused
                  value={values.description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={!!touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                  sx={{ span: 2 }} // adjust width as needed
                />

                {/* </Stack> */}
              </Box>

              <Stack
                direction="row"
                alignItems="center"
                justifyContent="end"
                padding={1}
                width="100%"
              >
                {/* RIGHT SIDE BUTTON GROUP */}
                <Stack direction="row" spacing={2}>
                  <Box display="flex" alignItems="center" gap={1}>
                  
                      {mode == "EV" &&
                      HWevaldata.Attachment && 
                      (
                                          <Tooltip title="Homework View File">
                                            <IconButton
                                              size="small"
              color="primary"
              onClick={() =>
                              window.open(
                                `${baseurl1}uploads/images/${HWevaldata.Attachment}`,
                                "_blank"
                              )
                            }
                                            >
                                              <PreviewIcon />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                  </Box>
                  {/* <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    onClick={() => handleApplyClick(values)}
                  >
                    Assign
                  </Button>

                  <Button
                    type="reset"
                    variant="contained"
                    color="error"
                    size="small"
                  >
                    Reset
                  </Button> */}
                </Stack>
              </Stack>
              {/* SUMMARY CARDS */}
<Box display="flex" gap={2} padding={1} flexWrap="wrap">

  {/* TOTAL */}
  <Paper sx={{ p: 2, minWidth: 120, textAlign: "center", background: "#f1efea" }}>
    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
      {totalCount}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      TOTAL
    </Typography>
  </Paper>

  {/* EVALUATED */}
  <Paper sx={{ p: 2, minWidth: 120, textAlign: "center", background: "#f1efea" }}>
    <Typography variant="h4" color="green" sx={{ fontWeight: "bold" }}>
      {evaluatedCount}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      EVALUATED
    </Typography>
  </Paper>

  {/* PENDING */}
  <Paper sx={{ p: 2, minWidth: 120, textAlign: "center", background: "#f1efea" }}>
    <Typography variant="h4" color="orange" sx={{ fontWeight: "bold" }}>
      {pendingCount}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      PENDING
    </Typography>
  </Paper>

  {/* RESUBMIT */}
  <Paper sx={{ p: 2, minWidth: 120, textAlign: "center", background: "#f1efea" }}>
    <Typography variant="h4" color="red" sx={{ fontWeight: "bold" }}>
      {resubmitCount}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      RESUBMIT
    </Typography>
  </Paper>

</Box>

{/* /*Datagrid*/}
              <Box sx={{ gridColumn: "span 4", display: "flex", gap: 2 }}>
                <Box
                  flex={1}
    height="420px"
    margin={1}
                  // height={dataGridHeight}
                  //  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    // rows={rows}
                    rows={studrows}
                    columns={StudColumn}
                    // editMode="cell"
                    // isCellEditable={(params) => {
                    //   const isInEditMode =
                    //     rowModesModel[params.id]?.mode === GridRowModes.Edit;

                    //   // Enable editing only for the Description column when row is in edit mode
                    //   if (isInEditMode && params.field === "Description") {
                    //     return true;
                    //   }

                    //   return false;
                    // }}
                    disableSelectionOnClick
                    // rowModesModel={rowModesModel}
                    // onRowModesModelChange={handleRowModesModelChange}
                    // onRowEditStop={handleRowEditStop}
                    // processRowUpdate={processRowUpdate}
                    getRowId={(row) => row.StudentID}
                    disableRowSelectionOnClick
                    // experimentalFeatures={{ newEditingApi: true }}
                    // onProcessRowUpdateError={(error) => {
                    //   console.error(
                    //     "Row update validation failed:",
                    //     error.message,
                    //   );

                    //   toast.error(error.message);
                    // }}
                    components={{
                      Toolbar: StudentTool,
                    }}
                    // componentsProps={{
                    //   toolbar: { setRows, setRowModesModel },
                    // }}
                    rowsPerPageOptions={[5, 10, 20]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    pagination
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                  />
                </Box>
                  <Box
                   flex={1}
    height="420px"
    margin={1}
                  // height={dataGridHeight}
                  //  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={rows}
  columns={EvalColumn}
  editMode="cell"   // ✅ enables double click editing

  isCellEditable={(params) =>
    ["Score", "Remarks", "Status", "AnswerSheet"].includes(params.field)
  }

  processRowUpdate={(newRow) => {
    const updatedRows = rows.map((row) =>
      row.DT_RECID === newRow.DT_RECID ? newRow : row
    );

    
    setRows(updatedRows);
    console.log(updatedRows, "--updatedRows");
    
    return newRow;
  }}

  getRowId={(row) => row.DT_RECID}
  disableSelectionOnClick
  experimentalFeatures={{ newEditingApi: true }}

  onProcessRowUpdateError={(error) => {
    console.error(error);
    toast.error(error.message);
  }}
                    components={{
                      Toolbar: EvalTool,
                    }}
                    componentsProps={{
                      toolbar: { setRows, setRowModesModel },
                    }}
                    rowsPerPageOptions={[5, 10, 20]}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                    pagination
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                  />
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-end"
                mt="15px"
                gap="20px"
                padding={1}
              >
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="15px"
                  gap={formGap}
                >
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    // loading={isLoading}
                   onClick={() => handleSaveButtonClick(values)}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </React.Fragment>
  );
};

export default EditHwevaluation;
